<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header pb-0">
            <p class="text-uppercase text-center">Gestión de Usuarios</p>
          </div>
          <hr class="horizontal dark" />
          <div class="card-body">
            Modo: {{ modeActual }}
            <form role="form" @submit.stop.prevent="sendData">
              <div class="row">
                <div class="col-md-4">
                  <label for="example-text-input" class="form-control-label"
                    >RFC</label
                  >
                  <input
                    class="form-control"
                    type="text"
                    disabled
                    v-model="model.rfc"
                  />
                </div>
                <div class="col-md-4">
                  <label for="example-text-input" class="form-control-label"
                    >CORREO</label
                  >
                  <input
                    disabled
                    class="form-control"
                    type="text"
                    v-model="model.correo"
                  />
                </div>
                <div class="col-md-8">
                  <label for="example-text-input" class="form-control-label"
                    >PASSWORD</label
                  >
                  <input
                    class="form-control"
                    type="password"
                    v-model="model.password"
                  />
                </div>
                <div class="col-md-8">
                  <label for="example-text-input" class="form-control-label"
                    >TOKEN</label
                  >
                  <input
                    class="form-control"
                    type="text"
                    v-model="model.token"
                    :disabled="activeData"
                  />
                </div>
                <div class="col-md-4">
                  <label for="example-text-input" class="form-control-label"
                    >X-CLIENT-ID</label
                  >
                  <input
                    class="form-control"
                    type="text"
                    v-model="model.xCorrelation"
                    :disabled="activeData"
                  />
                </div>
              </div>
              <hr class="horizontal dark" />
              <div class="text-center">
                <p class="text-uppercase text-sm mb-2 text-center">
                  Modo de Conexión Actual
                  <span
                    class="badge bg-badge-teal ms-2"
                    v-if="modeActual == 'DEV'"
                    >{{ modeActual }}</span
                  >
                  <span class="badge bg-success ms-2" v-else>{{
                    modeActual
                  }}</span>
                </p>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <label>
                    <input
                      type="checkbox"
                      v-model="isDev"
                      class="check-verde"
                    />
                    Conexión Desarrollo
                  </label>
                </div>

                <div class="col-md-5"></div>
                <div class="col-md-2">
                  <argon-button size="sm" class="bg-gray mt-3" type="submit">
                    Actualizar
                  </argon-button>
                </div>
                <div class="col-md-5"></div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import usuario from "../../api/usuario";
import Swal from "sweetalert2";
// import ArgonCheckbox from "@/components/ArgonCheckbox.vue";
import ArgonButton from "@/components/ArgonButton.vue";
//import SwitchArgon from "@/components/ArgonSwitch.vue";
// import Swal from "sweetalert2";
export default {
  components: {
    //  SwitchArgon,
    ArgonButton,
  },
  async mounted() {
    await this.getDataUser();
  },
  computed: {
    isDev: {
      get() {
        return this.model.mode === "DEV";
      },
      set(value) {
        this.model.mode = value ? "DEV" : "PRO";
        this.activeData = value;
      },
    },
  },
  data() {
    return {
      activeData: true,
      modeActual: localStorage.getItem("mode"),
      model: {
        rfc: "",
        correo: "",
        token: "",
        xCorrelation: "",
        password: "",
        modeCheckbox: "",
        mode: "",
      },
    };
  },
  methods: {
    changeMode(value) {
      alert(JSON.stringify(value));
      this.model.mode = value ? "DEV" : "PROD";
      this.activeData = this.model.mode ? "DEV" : false;
    },
    toggleMode(val) {
      this.model.mode = val ? "DEV" : "PROD";
    },
    sendData() {
      this.model.tokenSesion = localStorage.getItem("token");
      if (this.model.password && this.model.token && this.model.xCorrelation) {
        if (this.model.mode != this.modeActual) {
          Swal.fire({
            title: "Confirmación",
            text: "¿Seguro que quieres cambiar a modo? " + this.model.mode,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Continuar",
            cancelButtonText: "Cancelar",
            confirmButtonColor: "#28a745",
            cancelButtonColor: "#535FA8",
          }).then((result) => {
            if (result.isConfirmed) {
              usuario
                .updateUser(this.model)
                .then((result) => {
                  this.model.rfc = result.data.rfc;
                  this.model.correo = result.data.correo;
                  this.model.password = result.data.password;
                  this.model.token = result.data.token;
                  this.model.xCorrelation = result.data.xCorrelation;
                  this.model.mode = result.data.mode;
                  this.modeActual = result.data.mode;
                  localStorage.setItem("mode", this.model.mode);
                  Swal.fire({
                    title: "Actualización",
                    text: "Datos Actualizados Correctamente",
                    icon: "success",
                    confirmButtonColor: "success",
                    confirmButtonText: "Continuar",
                  });
                })
                .catch((error) => {
                  Swal.fire({
                    title: "Error Actualización de Datos",
                    text: error,
                    icon: "error",
                    confirmButtonColor: "error",
                    confirmButtonText: "Continuar",
                  });
                });
            } else {
              this.model.mode = this.modeActual;
            }
          });
        } else {
          usuario
            .updateUser(this.model)
            .then((result) => {
              this.model.rfc = result.data.rfc;
              this.model.correo = result.data.correo;
              this.model.password = result.data.password;
              this.model.token = result.data.token;
              this.model.xCorrelation = result.data.xCorrelation;
              this.model.mode = result.data.mode;
              this.modeActual = result.data.mode;
              localStorage.setItem("mode", this.model.mode);
              Swal.fire({
                title: "Actualización",
                text: "Datos Actualizados Correctamente",
                icon: "success",
                confirmButtonColor: "success",
                confirmButtonText: "Continuar",
              });
            })
            .catch((error) => {
              Swal.fire({
                title: "Error Actualización de Datos",
                text: error,
                icon: "error",
                confirmButtonColor: "error",
                confirmButtonText: "Continuar",
              });
            });
        }
      } else {
        Swal.fire({
          title: "No es posible actualizar",
          text: "Faltan datos obligatorios para actualizar",
          icon: "warning",
          confirmButtonColor: "success",
          confirmButtonText: "Continuar",
        });
      }
    },
    getDataUser() {
      this.model.tokenSesion = localStorage.getItem("token");
      usuario
        .getDataUser(this.model)
        .then((result) => {
          this.model.rfc = result.data.rfc;
          this.model.correo = result.data.correo;
          this.model.password = result.data.password;
          this.model.token = result.data.token;
          this.model.xCorrelation = result.data.xCorrelation;
          this.model.mode = result.data.mode;
          this.activeData = this.model.mode ? "DEV" : false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss">
$teal: #28a745;

.check-verde {
  accent-color: $teal;
}
.bg-badge-teal {
  background-color: #20c997;
  color: white;
}
</style>
